import * as React from 'react';

import StatusMain from '../../components/StatusMain';
import MainMenu from '../../containers/MainMenu';
import Navbar from '../../containers/Navbar';
import i18n from '../../resources/i18n';
/**
 * 受講/実績状況画面
 * @param props
 */
const Status: React.FC<any> = props => {
	let tableNumber = 0;
	if (props.location.state && props.location.state.tableNumber) {
		tableNumber = props.location.state.tableNumber;
	}
	return (
		<>
			<MainMenu />
			<Navbar title={i18n.t('Status_0001')} />
			<StatusMain tableNumber={tableNumber} />
		</>
	);
};

export default Status;



// WEBPACK FOOTER //
// ./src/pages/personal/Status.tsx